import { render, staticRenderFns } from "./MbgSelect.vue?vue&type=template&id=017cc9d8&"
import script from "./MbgSelect.vue?vue&type=script&lang=js&"
export * from "./MbgSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports